// extracted by mini-css-extract-plugin
export default {"overlay":"Gx-z","bodyOpen":"Hx-z","content":"Ix-z","header":"Jx-z","close":"Kx-z","closeNoHeading":"Lx-z"};